import { Env } from '@/consts/Env';
import { AppRoutes } from '@/i18n/constants';

export const isFairPlayEnabled = () => Env.NEXT_PUBLIC_FAIR_PLAY_ENABLED === 'true';

export const isFairPlayRouteBlocked = (pathname: string) => (
  pathname.includes(AppRoutes.fairPlay) && !isFairPlayEnabled()
);
